import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "priceInput",
    "display",
    "plusButton",
    "minusButton",
    "destroyInput",
  ];
  static values = { price: Number };

  connect() {
    this.updateButtonVisibility();
  }

  increment() {
    const currentValue = parseInt(this.inputTarget.value) || 0;
    const newValue = currentValue + 1;
    this.inputTarget.value = newValue;
    this.displayTarget.textContent = newValue;
    this.destroyInputTarget.value = "false";
    this.updateTotalPrice(newValue);
    this.updateButtonVisibility();
  }

  decrement() {
    const currentValue = parseInt(this.inputTarget.value) || 0;
    if (currentValue > 0) {
      const newValue = currentValue - 1;
      this.inputTarget.value = newValue;
      this.displayTarget.textContent = newValue;
      this.destroyInputTarget.value = newValue === 0 ? "true" : "false";
      this.updateTotalPrice(newValue);
      this.updateButtonVisibility();
    }
  }

  updateTotalPrice(quantity) {
    const totalPrice = quantity * this.priceValue;
    this.priceInputTarget.value = totalPrice;
  }

  updateButtonVisibility() {
    const currentValue = parseInt(this.inputTarget.value) || 0;

    if (currentValue === 0) {
      this.minusButtonTarget.classList.add("hidden");
    } else {
      this.minusButtonTarget.classList.remove("hidden");
    }
  }
}
